module.exports = __webpack_public_path__ + "media/buttons/google-play-badge-120255d3.png";